/**
 * Created by Ning Jiang on 11/22/2016.
 */

//Important! This pixi import business need to be at the top of the file. We need to attach PIXI to the window scope in order for our code to work, because we use PIXI in the old global way.
//The new way would be like this for example: new Sprite(); + A "normal"  import of Sprite from pixi."Not like we normaly

import "pixi-spine";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {GameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/GameModuleConfig";
import {ImmortalFruitsGameModuleConfig} from "./ImmortalFruitsGameModuleConfig";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {TimelineReelsController} from "@nolimitcity/slot-game/bin/timelinegameround/reels/TimelineReelsController";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {WinFieldController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinFieldController";
import {IFWinFieldController} from "./gameround/initialWin/IFWinFieldController";


require("gsap");

export class ImmortalFruits extends SlotGame {
    public static timelineReelsController:TimelineReelsController;
    private static gameRoundManager:GameRoundManager;
    constructor() {
        super(ImmortalFruitsGameModuleConfig.instance);
    }

    protected initGame():void {
        if (GameModuleConfig.instance.GAME_ROUND_CONFIG) {
            Reels.init();
            ImmortalFruits.timelineReelsController = TimelineReelsController.instance;
            ImmortalFruits.gameRoundManager = new GameRoundManager(GameModuleConfig.instance.GAME_ROUND_CONFIG());
        }
        else {
            super.initGame();
        }

    }
    protected createWinFieldController(): WinFieldController {
        return new IFWinFieldController();
    }

    getGameRules():Promise<string> {
        return super.getGameRules().then(value => {
            const bonusWheelPrice:number | undefined = ImmortalFruits.api.bonusFeatures.getFeatureDataByName("BONUS_WHEEL")?.price;
            if (bonusWheelPrice == undefined){
                ImmortalFruits.api.warn("Can't find BONUS_WHEEL price");
                return value;
            }

            const data: any = {
                replaceSlotsInGameRules: ImmortalFruits.api.gameClientConfiguration.replaceSlotsInGameRules,
                replaceWincapInfo:ImmortalFruits.api.gameClientConfiguration.replaceWincapInfo
            };

            let renderedData: string = ImmortalFruits.api.translations.render(value, data);
            renderedData = renderedData.replace("#BONUS_WHEEL_PRICE", ""+bonusWheelPrice);
            return renderedData;
        });

    }

    getPaytable(): Promise<string> {
        return super.getPaytable().then((value: string) => {
            value = value.replace(new RegExp("#isNotUSSweep", "g"), (ImmortalFruits.api.translations.language==="us-sweepstakes" ? "isNotUSSweepLang" : ""));
            value = value.replace(new RegExp("#isUSSweep", "g"), (ImmortalFruits.api.translations.language==="us-sweepstakes" ? "" : "isUSSweepLang"));
            value = value.replace(new RegExp("#toShowXWheelPot","g"),((ImmortalFruits.api.gameClientConfiguration.jurisdictionName === "ES" || ImmortalFruits.api.gameClientConfiguration.jurisdictionName === "LT"|| ImmortalFruits.api.gameClientConfiguration.jurisdictionName === "PT")?"toShowXWheelPotText":""));
            value = value.replace(new RegExp("#toNotShowXWheelPot","g"),((ImmortalFruits.api.gameClientConfiguration.jurisdictionName !== "ES" && ImmortalFruits.api.gameClientConfiguration.jurisdictionName !=="LT"&& ImmortalFruits.api.gameClientConfiguration.jurisdictionName !== "PT")?"toNotShowXWheelPotText":""));
            return value;
        });
    }

    start(): Promise<NolimitPlugin> {
        EventHandler.dispatchEvent(new GameEvent("onGameStart"));
        return super.start();
    }


    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L2",
                    "L2",
                    "L2",
                    "L5",
                    "L5",
                    "L5"
                ],
                [
                    "L3",
                    "L3",
                    "L1",
                    "L1",
                    "L1",
                    "L1"
                ],
                [
                    "M1",
                    "M1",
                    "M1",
                    "M1",
                    "L5",
                    "L5"
                ],
                [
                    "L1",
                    "L1",
                    "M2",
                    "M2",
                    "M2",
                    "M2"
                ],
                [
                    "L4",
                    "L4",
                    "L4",
                    "L4",
                    "M2",
                    "M2"
                ]
            ],
            "evaluatedArea": [
                [
                    "L2",
                    "L2",
                    "L5",
                    "L5"
                ],
                [
                    "L3",
                    "L1",
                    "L1",
                    "L1"
                ],
                [
                    "M1",
                    "M1",
                    "M1",
                    "L5"
                ],
                [
                    "L1",
                    "M2",
                    "M2",
                    "M2"
                ],
                [
                    "L4",
                    "L4",
                    "L4",
                    "M2"
                ]
            ],
            "betLineWins": [],
            "totalBetLineWinnings": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "currentMultiplier": 1,
            "bonusWheelTriggered": false,
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "nearWinBigWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "wheelOneValues": [
                0,
                3,
                5,
                1,
                10,
                3,
                5,
                100,
                1,
                25
            ],
            "wheelTwoValues": [
                0,
                3,
                30,
                3,
                15,
                5,
                15,
                250,
                5,
                25
            ],
            "wheelThreeValues": [
                50,
                5,
                100,
                5,
                20,
                5,
                25,
                2500,
                10,
                50
            ],
            "wheelLevelBefore": 1,
            "wheelLevelAfter": 1,
            "levelPositionsTakenBefore": [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "levelPositionsTakenAfter": [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "totalWheelTimesBetCollectedBefore": 0,
            "totalWheelTimesBetCollectedAfter": 0,
            "landedWheelIndex": -1,
            "landedWheelValue": -1,
            "featureBuyTimesBetValue": [
                {
                    "name": "BONUS_WHEEL",
                    "type": "FREESPIN",
                    "price": 75
                }
            ],
            "wasFeatureBuy": false,
            "featureBet": false,
            "gambleSuccess": false,
            "gambleCollect": false,
            "playerActions": {},
            "gambleModeChosen": -1,
            "gambleOptionPicked": -1,
            "numberOfGamblesAllowed": 5,
            "gambleOptions": {}
        };
    }

}